<template>
    <div>
      <!-- 追加 -->
      <el-button class="glance" size="small" @click="onClick" circle>
        <i class="el-icon-plus"></i>
      </el-button>
    </div>
  </template>
  <script>
  export default {
    methods: {
      onClick(event) {
        if (this.$listeners.click) {
          this.$listeners.click()
          event.stopPropagation();
        }
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .glance {
    border-radius: 25px!important;
    width: 26px;
    height: 26px;
    padding: 0;
    background: linear-gradient(180deg, #1C838C 0%, #4CB6BF 100%);

  }
  .el-icon-plus:before{
    font-size: 16px;
    color: #FFFFFF;
  }
  </style>
